import { render, staticRenderFns } from "./DialogPlantao.vue?vue&type=template&id=73e6903c"
import script from "./DialogPlantao.vue?vue&type=script&lang=js"
export * from "./DialogPlantao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports